const initialState = {};

export default (state = {}, action) => {
  switch (action.type) {
    case 'LOGOUT':
      return {
        initialState,
      };
    default:
      return state;
  }
};
